
export default class FixedMenu {

    constructor() {
        this.settings = {
            el: document.querySelector('[data-block="header"]'),
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.el != null) {
            const scrollThreshold = 175;
            const onScrollDiv = document.querySelector('.js-on-scroll');
            const backgroundColour = 'linear-gradient(90deg, #dbd4e2 31.84%, #8fc0e0 77.89%)';
            const borderBottom = document.querySelector('.js-on-scroll-border');
            const logoImage = document.querySelector('.js-on-scroll-logo');
            const button = document.querySelector('.js-on-scroll-button');
            const smallerLogoImage = document.querySelector('.js-on-scroll-smaller-logo');
            const topNav = document.querySelector('.js-top-nav');
            const header = document.querySelector('.js-header');
            const logoImageSrc = logoImage.src;

            window.addEventListener('scroll', () => {
                const scrollY = window.scrollY;

                if (scrollY > scrollThreshold) {
                    this.settings.el.style.position = 'fixed';
                    this.settings.el.style.top = '0';
                    this.settings.el.style.background = backgroundColour;
                    header.classList.add('active');
                    header.classList.remove('h-[153px]');
                    header.classList.add('h-[119px]');
                    header.classList.add('xl:h-[136px]');
                    onScrollDiv.classList.remove('xl:w-[70%]');
                    onScrollDiv.classList.remove('pt-6');
                    onScrollDiv.classList.add('py-4');
                    topNav.classList.remove('xl:flex');
                    borderBottom.classList.remove('xl:border-b');
                    logoImage.src = smallerLogoImage.src;
                    logoImage.classList.remove('xl:max-h-[140px]');
                    button.classList.remove('hidden');
                } else {
                    this.settings.el.style.position = 'absolute';
                    this.settings.el.style.background = 'transparent';
                    header.classList.remove('active');
                    header.classList.remove('h-[119px]');
                    header.classList.remove('xl:h-[136px]');
                    header.classList.add('h-[153px]');
                    onScrollDiv.classList.add('xl:w-[70%]');
                    onScrollDiv.classList.add('pt-6');
                    topNav.classList.add('xl:flex');
                    borderBottom.classList.add('xl:border-b')
                    logoImage.src = logoImageSrc;
                    logoImage.classList.add('xl:max-h-[140px]');
                    button.classList.add('hidden');
                }
            });

        }

    }

};

new FixedMenu();
